<template>
    <div class="relative privacy-police-page content-page">
        <div class="px30 pt30">
            <router-link
                :to="{
                    path: '/login',
                }"
                class="table"
            >
                <Close icon="back" />
            </router-link>
        </div>
        <div class="px30 py-8" v-html="content"></div>
    </div>
</template>

<script>
import Close from "../components/UI/Close";
export default {
    name: "TermsOfService",
    components: { Close },
    data: function() {
        return {
            content: "",
        };
    },
    mounted() {
        this.getContent();
    },
    methods: {
        getContent: function() {
            this.$http.get("pages/terms_of_service").then(res => {
                if (res && res.status !== undefined && res.status) {
                    this.content = !!res.data.content ? res.data.content : "";
                }
            });
        },
    },
};
</script>
